import { render, staticRenderFns } from "./GuideBookPaperFundingIcon.vue?vue&type=template&id=5266176c"
import script from "./GuideBookPaperFundingIcon.vue?vue&type=script&lang=js"
export * from "./GuideBookPaperFundingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports